import React from "react";
import {
  Box,
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import HeroSection from "./HeroSection";
import ProblemSection from "./ProblemSection";
import SolutionSection from "./SolutionSection";
import FooterSection from "./FooterSection";
import { CookiesPopup } from "../../cookies/CookiesPopup";

const theme = createTheme({
  palette: {
    primary: {
      lighter: "#93c5fd",
      light: "#60a5fa",
      main: "#2563eb",
      dark: "#1e40af",
      darker: "#1e3a8a",
      contrastText: "#ffffff",
    },
    secondary: {
      lighter: "#6ee7b7",
      light: "#34d399",
      main: "#10b981",
      dark: "#059669",
      darker: "#047857",
      contrastText: "#ffffff",
    },
    error: {
      lighter: "#fecaca", 
      light: "#f87171", 
      main: "#ef4444",
      dark: "#b91c1c", 
      darker: "#7f1d1d", 
      contrastText: "#ffffff",
    },
  },
  typography: {
    // Match Tailwind's default font stack exactly
    fontFamily: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    h1: {
      // Matches Tailwind's text-4xl lg:text-5xl font-bold
      fontSize: "2.25rem", // 36px (text-4xl)
      fontWeight: 700, // font-bold
      lineHeight: 1.1, // leading-tight
      "@media (min-width: 1024px)": {
        fontSize: "3rem", // 48px (text-5xl)
        lineHeight: 1.1,
      },
    },
    h2: {
      // Matches Tailwind's text-xl lg:text-2xl
      fontSize: "1.25rem", // 20px (text-xl)
      fontWeight: 400, // normal weight
      lineHeight: 1.75, // leading-relaxed
      "@media (min-width: 1024px)": {
        fontSize: "1.5rem", // 24px (text-2xl)
        lineHeight: 1.75,
      },
    },
    h3: {
      fontSize: "1.5rem", 
      fontWeight: 600,
      lineHeight: 1.5,
      "@media (min-width: 1024px)": {
        fontSize: "1.875rem",
      },
    },
    body1: {
      fontSize: "1rem", // 16px
      lineHeight: 1.5,
      fontWeight: 400,
    },
    body2: {
      fontSize: "0.875rem", // 14px (text-sm)
      lineHeight: 1.5,
      fontWeight: 400,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 600,
        },
        sizeLarge: {
          padding: '12px 32px',
          fontSize: '16px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

function VideoLandingPage() {
  return (
    <ThemeProvider theme={theme}>
      <Box>
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <FooterSection />
        <CookiesPopup/>
      </Box>
    </ThemeProvider>
  );
}

export default VideoLandingPage;
